import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      {/* Hero Section - Ultra Premium Notebooks */}
      <section className="hero-section">
        <div className="hero-image">
          <img src="/main/main1.png" alt="Premium notebook writing desk" />
        </div>
        <div className="hero-content">
          <h1>ultra premium notebooks</h1>
          <p>
            our notebooks pair carefully selected writing paper with dependable
            bindings. every design puts writing comfort first and offers smooth
            performance for all types of pens
            including fountain pens, rollerballs, ballpoint, gel pens, and fiber
            tip pens.
          </p>
          <Link to="/shop" onClick={toTop} className="hero-button">
            shop now
          </Link>
        </div>
      </section>

      {/* Twin-Ring Notebooks Section */}
      <section className="notebook-section">
        <div className="notebook-content">
          <div className="notebook-text">
            <h2>NEW! refillable twin-ring notebooks</h2>
            <p className="preorder-text">Pre-order now &amp; save 15%</p>
            <p className="notebook-description">
              smooth, pen-friendly paper in a flexible twin-ring binding.
            </p>
            <ul className="notebook-features">
              <li>176 pages of smooth 68 gsm writing paper</li>
              <li>Classic A5 size: 148 x 210 mm</li>
              <li>Durable twin ring binding</li>
              <li>Micro-perforated pages</li>
              <li>Refillable design for longer use</li>
            </ul>
            <Link to="/shop" onClick={toTop} className="notebook-button">
              pre-order
            </Link>
          </div>
        </div>
        <div className="notebook-image">
          <img src="/main/main2.png" alt="Refillable twin-ring notebook" />
        </div>
      </section>

      {/* Fountain Pen Bundles Section */}
      <section className="bundles-section">
        <div className="bundles-image">
          <img src="/main/main3.png" alt="Fountain pen starter bundle" />
        </div>
        <div className="bundles-content">
          <p className="new-text">
            NEW TO FOUNTAIN PENS?
            <br />
            START HERE
          </p>
          <h2>Fountain Pen Bundles</h2>
          <p className="bundles-description">
            Build your perfect writing setup and save 15%. Each bundle pairs a
            thoughtfully selected fountain pen with a tunrisefield notebook and
            ink, giving you everything you need for a superior writing
            experience.
          </p>
          <Link to="/shop" onClick={toTop} className="bundles-button">
            shop now
          </Link>
        </div>
      </section>

      {/* Latest Products Section */}
      <section className="products-section">
        <h2>latest products</h2>
        <div className="products-grid">
          {productData.slice(0, 12).map((product) => (
            <Link
              to={`/shopDetails/${product.id}`}
              onClick={toTop}
              key={product.id}
              className="product-card"
            >
              <div className="product-image-container">
                <img
                  src={product.image}
                  alt={product.name}
                  className="product-image"
                />
                {product.onSale && <span className="sale-badge">Sale</span>}
              </div>
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-price">${product.price}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Exotic Paper Section */}
      <section className="exotic-paper-section">
        <h2>exotic paper</h2>
        <div className="exotic-paper-grid">
          <div className="exotic-paper-item">
            <img
              src="/main/main4-1.png"
              alt="Cotton blend writing paper"
              className="exotic-paper-image"
            />
            <h3>cotton-blend writing paper</h3>
            <p>
              a balanced blend of responsibly sourced wood pulp and cotton gives
              each page a soft hand, controlled ink absorption, and a comfortable
              writing surface.
            </p>
            <Link to="/shop" onClick={toTop} className="exotic-paper-link">
              cotton-blend notebooks →
            </Link>
          </div>
          <div className="exotic-paper-item">
            <img
              src="/main/main4-2.png"
              alt="High opacity writing paper"
              className="exotic-paper-image"
            />
            <h3>high-opacity paper</h3>
            <p>
              lightweight, high-opacity sheets reduce ghosting while preserving
              a smooth surface and comfortable feedback for everyday writing.
            </p>
            <Link to="/shop" onClick={toTop} className="exotic-paper-link">
              high-opacity notebooks →
            </Link>
          </div>
          <div className="exotic-paper-item">
            <img
              src="/main/main4-3.png"
              alt="Silky cream writing paper"
              className="exotic-paper-image"
            />
            <h3>silky cream paper</h3>
            <p>
              beautiful book paper with a silky hand and the smoothest writing
              experience on the market.
            </p>
            <Link
              to="/shop"
              onClick={toTop}
              className="exotic-paper-link"
            ></Link>
          </div>
          <div className="exotic-paper-item">
            <img
              src="/main/main4-4.png"
              alt="Ink responsive coated paper"
              className="exotic-paper-image"
            />
            <h3>ink-responsive paper</h3>
            <p>
              the ultimate sheening and shading paper for fountain pen inks.
              this micro-coated paper provides a subtle texture while making ink
              appear extra vivid and bright on the page.
            </p>
            <Link to="/shop" onClick={toTop} className="exotic-paper-link">
              ink-responsive notebooks →
            </Link>
          </div>
        </div>
        <div className="paper-performance-button">
          <Link to="/shop" onClick={toTop} className="paper-performance-btn">
            paper performance
          </Link>
        </div>
      </section>

      {/* Paper Performance Section */}
      <section className="paper-performance-section">
        <div className="paper-performance-image">
          <img src="/main/main5.png" alt="Fountain pen ink tests on paper" />
        </div>
      </section>

      {/* Distraction Free Design Section */}
      <section className="distraction-free-section">
        <h2>distraction free design</h2>
        <p className="distraction-free-description">
          everything you need, nothing you don't. our notebooks are the best
          place to store your thoughts, dreams, plans, and art.
        </p>

        <h3 className="binding-title">binding</h3>
        <div className="binding-grid">
          <div className="binding-item">
            <img
              src="/main/main6-1.png"
              alt="360 Degree Flexibility"
              className="binding-image"
            />
            <h4>360° of flexibility - twin ring</h4>
            <p>
              our twin-ring notebook lays completely flat and also
              offers 360 degrees of flexibility for supreme comfort.
            </p>
          </div>
          <div className="binding-item">
            <img
              src="/main/main6-2.png"
              alt="Coverless Spine"
              className="binding-image"
            />
            <h4>exposed sewn spine</h4>
            <p>
              we have selected a stitched naked binding covered with bookbinding
              mesh to ensure maximum flexibility and strength.
            </p>
          </div>
          <div className="binding-item">
            <img
              src="/main/main6-3.png"
              alt="Swiss Binding"
              className="binding-image"
            />
            <h4>floating hardcover binding</h4>
            <p>
              this unique binding method attaches the book block only at the
              rear hinge, allowing an unusual degree of flexibility for a
              hardcover notebook.
            </p>
          </div>
          <div className="binding-item">
            <img
              src="/main/main6-4.png"
              alt="Lay Flat"
              className="binding-image"
            />
            <h4>lay-flat hardcover</h4>
            <p>
              our hardcover notebooks lay completely flat, allowing you to focus on
              writing and/or drawing.
            </p>
          </div>
        </div>
      </section>

      {/* Original Watermark Section */}
      <section className="watermark-section">
        <div className="watermark-content">
          <div className="watermark-image">
            <img src="/main/main7.png" alt="Sunrise field paper watermark" />
          </div>
          <div className="watermark-text">
            <h2>
              sunrise field
              <br />
              watermark
            </h2>
            <p>
              select tunrisefield papers carry our original sunrise field
              watermark, a quiet detail visible only when held to the light.
            </p>
            <Link to="/shop" onClick={toTop} className="watermark-button">
              shop premium notebooks
            </Link>
          </div>
        </div>
      </section>

      {/* Final Image Section */}
      <section className="final-image-section">
        <img src="/main/main8.png" alt="Tunrisefield notebook collection" />
      </section>
    </div>
  );
}

export default Main;
